import { useState } from 'react';

import Header from './components/Layout/Header';
import Meals from './components/Meals/Meals';
import Cart from './components/Cart/Cart';
import CartProvider from './store/CartProvider';

function App() {
  const [cartIsShown, setCartIsShown] = useState(false);
  const [activeCategory, setActiveCategory] = useState('all');

  const showCartHandler = () => {
    setCartIsShown(true);
  };

  const hideCartHandler = () => {
    setCartIsShown(false);
  };

  return (
    <CartProvider>
      {cartIsShown && <Cart onClose={hideCartHandler} />}
      <Header
        onShowCart={showCartHandler}
        activeCategory={activeCategory}
        onCategoryChange={setActiveCategory}
      />
      <main>
        <Meals activeCategory={activeCategory} />
      </main>
    </CartProvider>
  );
}

export default App;
